import React from "react";
import { Image } from "react-bootstrap";

const VerificationImage = () => {
  return (
    <>
      <div className="login-image-holder d-xl-block d-lg-block d-md-none d-none">
        <div className="d-flex justify-content-end align-items-center">
          <div className="pe-3">
            <Image src="/assets/images/DIDI.svg" />
          </div>
        </div>
        <div className="pb-5 position-relative  px-4">
          <Image
            src="/assets/images/verification-img.png "
            className="m-auto d-flex login-verification-img"
          />
        </div>
      </div>
    </>
  );
};

export default VerificationImage;
